import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { formatDate } from "@/lib/format";
import { Loading, Button, Field, SeverityTag, TierBadge } from "@/components/kit";
import { LogOut } from "lucide-react";

export default function Profile() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [member, setMember] = useState(null);
  const [memberships, setMemberships] = useState([]);
  const [pwd, setPwd] = useState({ current: "", next: "" });
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.getMember(user.member_id).then(setMember).catch(() => {});
    api.memberMemberships(user.member_id).then(setMemberships).catch(() => {});
  }, [user.member_id]);

  const changePwd = async () => {
    if (!pwd.current || pwd.next.length < 6) return toast.error("Password baru minimal 6 karakter");
    setBusy(true);
    try { await api.changePassword(pwd.current, pwd.next); toast.success("Password diperbarui"); setPwd({ current: "", next: "" }); }
    catch (e) { toast.error(e.message); } finally { setBusy(false); }
  };

  if (!member) return <Loading />;

  return (
    <div className="space-y-6 fade-in">
      <div>
        <div className="hsc-label">Akun</div>
        <h1 className="font-display text-3xl text-white">Profil</h1>
      </div>

      <div className="rounded-2xl border border-[#1F1F22] bg-[#0A0A0C] p-5">
        <div className="flex items-center justify-between">
          <div>
            <div className="font-display text-xl text-white">{member.name}</div>
            <div className="text-[12px] text-[#6E6E73]">{member.phone || user.email || "—"}</div>
          </div>
          <TierBadge tier={member.tier} />
        </div>
      </div>

      <div>
        <div className="hsc-label mb-2">Membership</div>
        {!memberships.length ? <div className="text-sm text-[#6E6E73]">Tidak ada membership aktif.</div> : (
          <div className="space-y-2">
            {memberships.map((m, i) => (
              <div key={i} className="flex items-center justify-between rounded-lg border border-[#1F1F22] px-3 py-2 text-sm">
                <span className="text-white">{m.category}</span>
                <div className="flex items-center gap-2"><SeverityTag value={m.status} /><span className="text-[11px] text-[#6E6E73]">{formatDate(m.expires_at)}</span></div>
              </div>
            ))}
          </div>
        )}
      </div>

      <div className="rounded-2xl border border-[#1F1F22] p-5">
        <div className="hsc-label mb-3">Ubah Password</div>
        <div className="space-y-3">
          <Field label="Password Saat Ini"><input type="password" className="hsc-input" value={pwd.current} onChange={(e) => setPwd((s) => ({ ...s, current: e.target.value }))} /></Field>
          <Field label="Password Baru"><input type="password" className="hsc-input" value={pwd.next} onChange={(e) => setPwd((s) => ({ ...s, next: e.target.value }))} /></Field>
          <Button onClick={changePwd} disabled={busy}>Simpan</Button>
        </div>
      </div>

      <Button variant="danger" className="w-full" onClick={() => { logout(); navigate("/login", { replace: true }); }} data-testid="member-logout">
        <LogOut className="h-4 w-4" /> Keluar
      </Button>
    </div>
  );
}
